<template>
  <div class="contact-block-wrapper">
    <div class="contact-block">
      <epi-property
        v-if="icon"
        id="icon"
        text="Ändraikon"
      />
      <div class="contact-block__circle">
        <svgicon
          :name="icon"
          role="presentation"
          :original="true"
        />
      </div>

      <h4
        v-if="title || isEditable"
        v-edit="'Title'"
        class="contact-block__heading"
        v-text="title"
      />
      <slot />
      <a
        v-if="phone || isEditable"
        v-edit="'Phone'"
        :href="`tel:${phone}`"
        class="contact-block__link-item"
        v-text="phone"
      />

      <a
        v-if="(mailUrl && mailText) || isEditable"
        v-edit="'MailText'"
        :href="mailUrl"
        class="contact-block__link-item"
        v-text="mailText"
      />

      <div
        v-if="
          openingHoursHeadline1 ||
            openingHoursHeadline2 ||
            openingHoursHeadline3
        "
        class="contact-block__opening-hours-wrapper"
      >
        <p
          v-if="openingHoursHeadline1 || isEditable"
          v-edit="'OpeningHoursHeadline1'"
          class="contact-block__opening-hours"
          v-text="openingHoursHeadline1"
        />

        <p
          v-if="openingHoursHeadline2 || isEditable"
          v-edit="'OpeningHoursHeadline2'"
          class="contact-block__opening-hours"
          v-text="openingHoursHeadline2"
        />

        <p
          v-if="openingHoursHeadline3 || isEditable"
          v-edit="'OpeningHoursHeadline3'"
          class="contact-block__opening-hours"
          v-text="openingHoursHeadline3"
        />
      </div>
    </div>
  </div>
</template>

<script>
import "#/Illustrative/Diversity"
import "#/Illustrative/Card"
import "#/Illustrative/Cart"
import "#/Illustrative/Identify"
import "#/Illustrative/Settings"
import "#/Illustrative/Cookie"
import '#/Communication/Chatbot'
export default {
  name: "ContactBlock",
  props: {
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    phone: {
      type: String,
      default: ""
    },
    mailUrl: {
      type: String,
      default: ""
    },
    mailText: {
      type: String,
      default: ""
    },
    openingHoursHeadline1: {
      type: String,
      default: ""
    },
    openingHoursHeadline2: {
      type: String,
      default: ""
    },
    openingHoursHeadline3: {
      type: String,
      default: ""
    }
  }
}
</script>

<style lang="scss">
.contact-block-wrapper {
  margin-top: 4.25rem;

  @include media-breakpoint-up(md) {
    margin-top: 6rem;
  }
}

.contact-block {
  background: $color-white;
  padding: 4.25rem 3.5rem 2rem 3.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 2.1875rem;
  box-shadow: $box-shadow-primary;
  height: 100%;
  justify-content: flex-start;
  text-align: center;

  @include media-breakpoint-up(md) {
    padding: 4.25rem 0.5rem 2rem 0.5rem;
    border-right: 0.0625rem solid $color-grey-special;
  }

  @include media-breakpoint-up(lg) {
    padding: 4.25rem 2.5rem 2.5rem 2.5rem;
  }

  &__circle {
    padding: 1.25rem;
    max-width: 5.5rem;
    max-height: 5.5rem;
    background: white;
    border-radius: 50%;
    position: absolute;
    top: 0%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
    box-shadow: 0 0.25rem 0.5rem 0 rgb(249, 245, 245);

    .svg-icon {
      width: 3rem;
      height: 3rem;
    }
  }

  &__heading {
    margin: 0 0 0.5rem;
    text-transform: uppercase;

    @include font(text, 3, "black");
  }

  &__link-item {
    @include font(rubrik, 2, "bold");
  }

  &__opening-hours-wrapper {
    margin-top: 1rem;
    text-align: center;
    max-width: 100%;
  }

  &__opening-hours {
    margin: 0;

    @include font(text, 2, "light");

    @include media-breakpoint-up(sm) {
      @include font(text, 3, "light");
    }
  }

  // ajusts editorial button for changing icon
  .button--editbutton {
    margin: 0 auto 1.25rem auto;
  }
}
</style>
